import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";

export const Verify_stafftype_account = async (accountguid) => {

  if (!accountguid || typeof accountguid !== "string" || accountguid.trim() === "") {
    return { success: false, error: "Missing accountid" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
    return { success: false, error: "Contact service provider." };
  }

  try {
    const staffRef = collection(db, "companies", select_company_uid, "staff_accounts");
    const staffQuery = query(
      staffRef,
      where("accountguid", "==", accountguid)
    );
    const staffSnap = await getDocs(staffQuery);

    if (staffSnap.empty) {
      return { success: false, error: "Account is not of staff type." };
    }

    // fetch from main accounts collection
    const accQuery = query(
      collection(db, "accounts"),
      where("status", "==", true),
      where("guid", "==", accountguid)
    );

    const accSnap = await getDocs(accQuery);

    let accountInfo = {};
    if (!accSnap.empty) {
      const d = accSnap.docs[0];
      accountInfo = {
        account_id: d.id,
        ...d.data()
      };
    }

    const staffData = staffSnap.docs[0].data();

    return { success: true, data: staffData, accountinfo: accountInfo };

  } catch (err) {
    return {
      success: false,
      error: err?.message || "Unknown error"
    };
  }
};
